export function getServerClientTimeDiff(serverDate: string, timeZone: string) {
  const clientTime = new Date()
  const serverTimeInClientTimezone = new Date(new Date(serverDate).toLocaleString('en-US', { timeZone }))
  const timeDiff = clientTime.getTime() - serverTimeInClientTimezone.getTime()

  return timeDiff || 0
}
